var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","no-close-on-backdrop":_vm.preventClose},on:{"hide":_vm.hideModel},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]},proxy:true}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("inputField")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }